export default __webpack_public_path__ + "static/media/ptx3.32105213.jpg";